import {
  OrderDraftIcon,
  StoreManagedIcon,
  ProductAddIcon,
  CatalogIcon,
  ProductIcon,
  GaugeIcon,
  SettingsIcon,
  PackageIcon,
  QuestionCircleIcon,
  DiscountCodeIcon,
  SandboxIcon,
} from "@shopify/polaris-icons";
import Page404 from "../layouts/404";
import Dashboard from "../layouts/Dashboard";
import Login from "../layouts/Login";
import BundleDashboard from "../layouts/Bundles/index.jsx";
import CreateBundle from "../layouts/Bundles/Create/index.jsx";
import OrdersDashboard from "../layouts/Orders/index.jsx";
import CustomerReport from "../layouts/Reports/CustomerReport/index.jsx";
import UpdateBundle from "../layouts/Bundles/Update/index.jsx";
import ViewSingleBundle from "../layouts/Bundles/View/index.jsx";
import CouponDashboard from "../layouts/Coupons/index.jsx";
import CreateCoupon from "../layouts/Coupons/Create/index.jsx";
import StoreBoxesDashboard from "../layouts/StoreBoxes/index.jsx";
import CreateStoreBoxOrder from "../layouts/StoreBoxes/Create/index.jsx";
import SupportDashboard from "../layouts/SupportTickets/index.jsx";
import CreateSupportTicketForm from "../layouts/SupportTickets/Create/index.jsx";
import ProductDashboard from "../layouts/Products/index.jsx";
import Settings from "../layouts/Settings/index.jsx";
import Chatbot from "../layouts/chatbot/index.jsx";
import UpdateCoupon from "../layouts/Coupons/Update/index.jsx";

const PageRoutes = [
  {
    path: "login",
    element: Login,
    title: "login",
  },
  {
    path: "/dashboard",
    element: Dashboard,
    title: "Dashboard",
    icon: StoreManagedIcon,
    protected: true,
  },
  {
    path: "/orders",
    element: OrdersDashboard,
    title: "Orders",
    icon: OrderDraftIcon,
    protected: true,
  },

  {
    path: "/bundles",
    element: BundleDashboard,
    title: "Inventory",
    icon: ProductAddIcon,
    protected: true,
    subNavigationItems: [
      {
        path: "/bundles",
        element: BundleDashboard,
        title: "Bundles",
        icon: CatalogIcon,
        disabled: false,
        protected: true,
      },
      {
        path: "/products",
        element: ProductDashboard,
        title: "Products",
        icon: ProductIcon,
        disabled: false,
        protected: true,
      },
    ],
  },

  {
    path: "/bundles/create",
    element: CreateBundle,
    title: "Create Bundle",
    protected: true,
  },
  {
    path: "/bundles/update/:id",
    element: UpdateBundle,
    title: "Update bundle",
    protected: true,
  },

  {
    path: "/bundles/:id",
    element: ViewSingleBundle,
    protected: true,
    title: "Single Bundle",
  },

  {
    path: "/analytics/customers",
    element: CustomerReport,
    title: "Analytics",
    icon: GaugeIcon,
    protected: true,
    subNavigationItems: [
      {
        path: "/analytics/customers",
        element: CustomerReport,
        title: "Customer Listing",
        icon: OrderDraftIcon,
        disabled: false,
        protected: true,
      },
    ],
  },
  {
    path: "/store-boxes",
    element: StoreBoxesDashboard,
    title: "Others",
    icon: SandboxIcon,
    protected: true,
    subNavigationItems: [
      {
        path: "/store-boxes",
        element: StoreBoxesDashboard,
        title: "Store Boxes",
        icon: PackageIcon,
        protected: true,
      },
      {
        path: "/coupons",
        element: CouponDashboard,
        title: "Discount",
        icon: DiscountCodeIcon,
        protected: true,
      },
      {
        path: "/support",
        element: SupportDashboard,
        title: "Support",
        icon: QuestionCircleIcon,
        protected: true,
      },
    ],
  },

  {
    path: "/support/create",
    element: CreateSupportTicketForm,
    title: "Support",
    protected: true,
  },

  {
    path: "/coupons/create",
    element: CreateCoupon,
    title: "Crete Coupons",
    protected: true,
  },
  {
    path: "/coupons/update/:id",
    element: UpdateCoupon,
    title: "Update Coupons",
    protected: true,
  },
  {
    path: "/store-box-order/create",
    element: CreateStoreBoxOrder,
    title: "Crete Coupons",
    protected: true,
  },
  {
    path: "/settings",
    element: Settings,
    icon: SettingsIcon,
    protected: true,
    title: "Settings",
  },
  {
    path: "/chat",
    element: Chatbot,
    protected: false,
  },

  {
    path: "*",
    element: Page404,
    title: "404",
  },
];

export default PageRoutes;
